import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kallimast

  <span style="color:#85c1dc;">**FI:**</span>
  Kallein ensin

  <span style="color:#85c1dc;">**RU:**</span>
  Самые дорогие наверху
*/
/* @__NO_SIDE_EFFECTS__ */
const m990 = msg(
  mf`Kallimast`,
  mf`Kallein ensin`,
  mf`Самые дорогие наверху`,
)

export { m990 as 'w.saal.reasta.kallimast' }